import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { RADIUS } from 'common/constants/sizes';
import { WhiteSection } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import {
  convertMinutesToDisplayableTime,
  TIME_UNITS
} from 'common/utils/time.utils';

export const ChartContainer = styled(WhiteSection)`
  border-radius: ${RADIUS.small};
  height: 35rem;
  width: 100%;
`;

export const barSize = 50;

export const CHART_CONFIG = {
  gridConfig: { stroke: getColor('gray', 0.2) },
  bars: []
};

export const CustomizedXTick = ({
  x,
  y,
  width,
  height,
  fill,
  textAnchor,
  payload,
  slicedIterations
}) => {
  const iteration = _.find(slicedIterations, i => i.name === payload.value);
  const iterationName = _.get(iteration, 'iterationName', '-');
  const iterationDates = _.get(iteration, 'iterationDates', '-');
  return (
    <>
      <text
        x={x}
        y={y + 10}
        width={width}
        height={height}
        fill={getColor('shark')}
        textAnchor={textAnchor}
        fontWeight='bold'
      >
        {iterationName}
      </text>
      <text
        x={x}
        y={y + 25}
        width={width}
        height={height}
        fill={fill}
        textAnchor={textAnchor}
      >
        {iterationDates}
      </text>
    </>
  );
};

export const CustomizedYTick = ({
  x,
  y,
  width,
  height,
  fill,
  textAnchor,
  payload
}) => {
  return (
    <text
      x={x}
      y={y + 4}
      width={width}
      height={height}
      fill={fill}
      textAnchor={textAnchor}
    >
      {_.get(
        convertMinutesToDisplayableTime({
          minutes: payload.value,
          maxTimeUnit: TIME_UNITS.days
        }),
        'value',
        0
      )}
    </text>
  );
};
